import { memo } from 'react';
import { PhoneEventsOrg } from '@wetags/phone-events';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { DotRow, EventRowList, formatTime } from '../../utils/get-event-accordion-body';

export const VoicemailEvent = memo(
  ({ transcription, createdAt, callerName }: { transcription?: string; createdAt?: string; callerName?: string }) => {
    const { t } = useTranslation('calls');
    const [isAirEventsUiEnabled] = PhoneEventsOrg.useWetag('fe-air-events-ui');

    if (!isAirEventsUiEnabled) {
      return (
        <>
          <DotRow
            message={t('{{name}} left voicemail message', { name: callerName })}
            time={formatTime(createdAt)}
            hideDot
          />
          {transcription && (
            <Text
              textAlign='left'
              as='div'
              size='medium'
              css={{ fontStyle: 'italic', paddingLeft: theme.spacing(2.5), paddingTop: theme.spacing(2) }}
            >
              "{transcription}"
            </Text>
          )}
        </>
      );
    }

    return (
      <>
        <EventRowList
          events={[
            { message: t('{{name}} left voicemail message', { name: callerName }), time: formatTime(createdAt) },
          ]}
        />
        {transcription && (
          <Text
            textAlign='left'
            as='div'
            size='medium'
            css={{ fontStyle: 'italic', paddingLeft: theme.spacing(2.5), paddingTop: theme.spacing(2) }}
          >
            "{transcription}"
          </Text>
        )}
      </>
    );
  }
);

VoicemailEvent.displayName = 'VoicemailEvent';
